var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "classRecord" }, [
    _c("div", { staticClass: "classRecordDiv" }, [
      _c(
        "div",
        { staticClass: "classTitle" },
        [_c("Title", { attrs: { text: "学习记录" } })],
        1
      ),
      _c(
        "div",
        { staticClass: "classTab" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "听课记录", name: "classRecord" } },
                [_c("Listen")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "做题记录", name: "problemRecord" } },
                [_c("Problem")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "易错题集", name: "errorRecord" } },
                [_c("ErrorProblem")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "我的收藏", name: "myCollect" } },
                [_c("Collect")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "我的笔记", name: "myNotes" } },
                [_c("Notes")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }